import styled from 'styled-components';
import { LegacyContent } from 'components/legacy-content';

const ContentPadded = styled(LegacyContent)({
  paddingBottom: 24,
  overflow: 'visible',
});

export { ContentPadded };
